export default "/staticreactui/static/media/static/media/customer5.96ea774b.png";